import { useEffect } from 'react'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { SpecialTours } from 'pages/tours/main-page/components/special-tours'
import { TourDirections } from 'pages/tours/main-page/components/tour-directions'

import { PromotionsBlock } from 'widgets/avia'
import { HeaderTabs } from 'widgets/header-tabs'

import searchTour from 'entities/tour/models/search-tour/search-tour'
import tourListStore from 'entities/tour/models/tour-list/tour-list'
import { SearchFormTours } from 'entities/tour/ui/search-form-tours'

import { IS_DIGITAL_TOUR_SUPPORT_ENABLED } from 'shared/constants/tours'
import { BottomNavigation } from 'shared/ui/bottom-navigation'

import { BannerChat } from './components/banner'
import { LastTourAppeal } from './components/last-tour-appeal'
import { MyTours } from './components/my-tours'
import { useLastTourDocuments } from './model'
// import { HotTours } from './components/hot-tours'
// import { TourGuide } from './components/tour-guide/tour-guide'
import s from './styles.module.scss'

const MainPage = observer(() => {
  const dataForSearchTour = searchTour.getDataForSearchTour()
  const { data: tours = [] } = useLastTourDocuments()

  useEffect(() => {
    searchTour.cancelSearchEdit()
    tourListStore.resetTourList()
  }, [])

  return (
    <div className={s.mainPage}>
      <div className={clsx('bgGrey', s.container)}>
        <HeaderTabs module="tours" />

        <div className={s.wrapper}>
          <SearchFormTours dataForSearchTour={dataForSearchTour} />
          <div className="container">
            <BannerChat />
          </div>
          {!IS_DIGITAL_TOUR_SUPPORT_ENABLED && <LastTourAppeal />}
        </div>
      </div>

      {IS_DIGITAL_TOUR_SUPPORT_ENABLED && (
        <div className={s.tours}>
          <MyTours tours={tours} />
        </div>
      )}

      <div className={s.tours}>
        <TourDirections />
      </div>

      <div className={s.tours}>
        <SpecialTours />
      </div>

      <div className={s.promotions}>
        <PromotionsBlock type="tours" />
      </div>

      {/* <TourGuide /> */}

      <BottomNavigation activeId="home" />
    </div>
  )
})

export default MainPage
